// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"TradeGuide_clearfix_1Dv6J"};